import React from 'react';
import { IResourceIcon, IResourceIconProps } from './ResourceIcon';

export const StaffportalIcon: IResourceIcon = React.forwardRef<SVGSVGElement, IResourceIconProps>((props, ref) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    ref={ref}
  >
    <path
      d="M28 29.75C39.598 29.75 49 39.152 49 50.75H45.5C45.5 41.085 37.665 33.25 28 33.25C18.335 33.25 10.5 41.085 10.5 50.75H7C7 39.152 16.402 29.75 28 29.75ZM28 5.25C33.799 5.25 38.5 9.95101 38.5 15.75C38.5 21.549 33.799 26.25 28 26.25C22.201 26.25 17.5 21.549 17.5 15.75C17.5 9.95101 22.201 5.25 28 5.25ZM28 8.75C24.134 8.75 21 11.884 21 15.75C21 19.616 24.134 22.75 28 22.75C31.866 22.75 35 19.616 35 15.75C35 11.884 31.866 8.75 28 8.75Z"
      fill="white"
    />
    <mask
      id="mask0_staffportal"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="7"
      y="5"
      width="42"
      height="46"
    >
      <path
        d="M28 29.75C39.598 29.75 49 39.152 49 50.75H45.5C45.5 41.085 37.665 33.25 28 33.25C18.335 33.25 10.5 41.085 10.5 50.75H7C7 39.152 16.402 29.75 28 29.75ZM28 5.25C33.799 5.25 38.5 9.95101 38.5 15.75C38.5 21.549 33.799 26.25 28 26.25C22.201 26.25 17.5 21.549 17.5 15.75C17.5 9.95101 22.201 5.25 28 5.25ZM28 8.75C24.134 8.75 21 11.884 21 15.75C21 19.616 24.134 22.75 28 22.75C31.866 22.75 35 19.616 35 15.75C35 11.884 31.866 8.75 28 8.75Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_staffportal)">
      <rect width="56" height="56" fill="white" />
    </g>
  </svg>
));

StaffportalIcon.displayName = 'StaffportalIcon';
